var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue2-dropzone',{ref:("file-uploader-" + _vm.assetId + "-" + _vm.assetType),attrs:{"id":("file-uploader-" + _vm.assetId + "-" + _vm.assetType),"options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.emitFileUpload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }